import config from "../config";

export const GOOGLE_AUTH_URL_SIGNUP = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${config.CLIENT_ID_GOOGLE}&response_type=code&redirect_uri=${config.REDIRECT_URI_GOOGLE_SIGNUP}&scope=${config.SCOPE_GOOGLE}`;